import { authenticatedFetch } from "@/api/session";
const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ??
  "http://localhost:8000";

function getAuthHeaders() {
  const token = localStorage.getItem("access_token");

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

export type ChurchIntelligenceHealth = {
  status: "HEALTHY" | "STALE" | "UNKNOWN";
  last_successful_scan_at: string | null;
  calculated_at: string | null;
  members_evaluated: number | null;
  households_evaluated: number | null;
  duration_ms: number | null;
  freshness_target_minutes: number;
  open_care_items: number | null;
  in_progress_care_items: number | null;
};

export type SystemHealthResponse = {
  api_status: string;
  database_status: string;
  intelligence: ChurchIntelligenceHealth;
};

export type IntelligenceScanResult = {
  status: "SUCCESS" | "SKIPPED_LOCKED";
  intelligence: ChurchIntelligenceHealth;
};

async function parseResponse<T>(
  response: Response,
  errorMessage: string
): Promise<T> {
  if (!response.ok) {
    const body = await response.json().catch(() => null);

    throw new Error(
      body && typeof body.detail === "string"
        ? body.detail
        : errorMessage
    );
  }

  return response.json() as Promise<T>;
}

export async function getSystemHealth(
  churchId: string
): Promise<SystemHealthResponse> {
  const response = await authenticatedFetch(
    `${API_BASE_URL}/api/churches/${churchId}/system-health`,
    {
      headers: getAuthHeaders(),
    }
  );

  return parseResponse(
    response,
    "Failed to load system health"
  );
}

export async function runIntelligenceScan(
  churchId: string
): Promise<IntelligenceScanResult> {
  const response = await authenticatedFetch(
    `${API_BASE_URL}/api/churches/${churchId}/system-health/intelligence/run`,
    {
      method: "POST",
      headers: getAuthHeaders(),
    }
  );

  return parseResponse(
    response,
    "Failed to run intelligence scan"
  );
}